import { render, staticRenderFns } from "./DtExcel.vue?vue&type=template&id=1c243ffb&scoped=true&"
import script from "./DtExcel.vue?vue&type=script&lang=js&"
export * from "./DtExcel.vue?vue&type=script&lang=js&"
import style0 from "./DtExcel.vue?vue&type=style&index=0&id=1c243ffb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c243ffb",
  null
  
)

export default component.exports